import CommonHeader from "./CommonHeader"

export default CommonHeader
